export var widgetUrl = 'https://conversional-testing-v3.appspot.com';
